import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { UserNoAdminForm } from "../../interfaces/usernoadmin-form.interface";

const usersNoAdminUrlApi = environment.usersNoAdminUrlApi;
const blockUnblockUrlApi = environment.blockUnblockClientUserNoAdminById;

@Injectable()
export class UserNoAdminService {
  public userNoAdmin: UserNoAdminForm;

  constructor(private http: HttpClient) {}

  getUsers() {
    return this.http
      .request("GET", `${usersNoAdminUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getUserById(id: number) {
    return this.http
      .request("GET", `${usersNoAdminUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateUserById(id: number, userModel: UserNoAdminForm) {
    delete userModel.active;
    const body = userModel;
    return this.http
      .request("PUT", `${usersNoAdminUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createUser(userModel: UserForm) {
    delete userModel.password2;
    delete userModel.active;
    const body = userModel;
    return this.http
      .request("POST", `${usersNoAdminUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  changeStatusUserById(id: number, status: boolean) {
    const body = { active: !status };
    return this.http
      .request("PUT", `${blockUnblockUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteUserById(id: number) {
    return this.http
      .request("DELETE", `${usersNoAdminUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }
}
